import { apiGet, apiPost } from './client.js';

export const getOrderStats = (clientId) => {
  const q = clientId ? `?clientId=${clientId}` : '';
  return apiGet(`/orders/stats${q}`);
};

export const getOrders = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== '' && v != null) query.set(k, v);
  });
  return apiGet(`/orders?${query.toString()}`);
};

export const cancelOrder = (orderId, password) =>
  apiPost(`/orders/${encodeURIComponent(orderId)}/cancel`, { password });

export const getOrderMpStatus = (orderId) =>
  apiGet(`/orders/${encodeURIComponent(orderId)}/mp-status`);

export const refundOrder = (orderId, password, amount) =>
  apiPost(`/orders/${encodeURIComponent(orderId)}/refund`, {
    password,
    ...(amount != null ? { amount } : {}),
  });

export const getOrdersArchive = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== '' && v != null) query.set(k, v);
  });
  return apiGet(`/orders/archive?${query.toString()}`);
};

export const archiveBatch = (body) => apiPost('/orders/archive-batch', body);

export const exportOrdersArchive = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== '' && v != null) query.set(k, v);
  });
  return apiGet(`/orders/archive/export?${query.toString()}`);
};
